import * as Scroll from "react-scroll";

const scroll = Scroll.animateScroll;

export const scrollToTop = () => {
    scroll.scrollToTop()
}